var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#E0E3EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_39111)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1782_39111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5262 29.95C35.4648 29.9013 31 26.683 29.7745 26.914C29.1895 27.0175 28.855 27.4165 28.1838 28.2153C28.0758 28.3443 27.8162 28.6532 27.6145 28.873C27.1903 28.7346 26.7765 28.5662 26.3762 28.369C24.3104 27.3633 22.6412 25.6941 21.6355 23.6283C21.4381 23.2281 21.2697 22.8143 21.1315 22.39C21.352 22.1875 21.661 21.928 21.793 21.817C22.588 21.1495 22.9878 20.815 23.0912 20.2285C23.3035 19.0135 20.0875 14.518 20.0538 14.4775C19.9078 14.2691 19.7174 14.0956 19.4963 13.9698C19.2751 13.844 19.0287 13.7689 18.775 13.75C17.4715 13.75 13.75 18.5777 13.75 19.3907C13.75 19.438 13.8183 24.241 19.741 30.2658C25.7597 36.1817 30.562 36.25 30.6092 36.25C31.423 36.25 36.25 32.5285 36.25 31.225C36.2313 30.9722 36.1567 30.7266 36.0315 30.5061C35.9063 30.2856 35.7338 30.0957 35.5262 29.95Z",
    fill: "#A2AD1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_39111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1782_39111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fb3f0218902951a84b409e9311def73e.svg";
export { ForwardRef as ReactComponent };